import React from 'react';
import PropTypes from 'prop-types';

/**
 * UserSelectionCard - Shows selected user info with clear option
 *
 * Displays when a user filter is active in forms management
 *
 * @param {Object} props
 * @param {string} props.selectedUser - Selected user ID
 * @param {Array} props.portalUserList - List of all portal users
 * @param {Function} props.onClear - Callback when filter is cleared
 */
const UserSelectionCard = ({ selectedUser, portalUserList, onClear }) => {
  if (selectedUser === 'all' || !selectedUser) return null;

  const user = portalUserList?.find((u) => u.id?.toString() === selectedUser);
  if (!user) return null;

  const initials = `${user.userFirst?.[0]?.toUpperCase() || '?'}${
    user.userLast?.[0]?.toUpperCase() || ''
  }`;

  return (
    <div className="user-selection-card">
      <div className="user-selection-info">
        <div className="user-avatar">{initials}</div>
        <div className="user-selection-details">
          <strong>
            {user.userFirst} {user.userLast}
          </strong>
          <span className="user-selection-username">@{user.userName}</span>
        </div>
      </div>
      <button
        className="btn-clear-selection"
        onClick={onClear}
        title="Clear user filter"
      >
        ✕ Clear Filter
      </button>
    </div>
  );
};

UserSelectionCard.propTypes = {
  selectedUser: PropTypes.string.isRequired,
  portalUserList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      userFirst: PropTypes.string,
      userLast: PropTypes.string,
      userName: PropTypes.string,
    })
  ),
  onClear: PropTypes.func.isRequired,
};

UserSelectionCard.defaultProps = {
  portalUserList: [],
};

export default UserSelectionCard;
